// src/components/ListSection/ListSection.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import {  getSafeText} from '../../utils/valueResolver';

function ListSection({ items }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <section className="list-section no-border">
      <div className="list-table">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <div className={`list-row ${item.isBorderless ? 'no-border' : ''}`}>
              <div className="list-label">{item.label}</div>
              <div className="list-value">
                {item.image ? (
                  <img
                    src={item.image}
                    alt={item.alt}
                    width={item.width}
                    height={item.height}
                  />
                ) : (
                  getSafeText(item.value)
                )}
              </div>
            </div>
            {item.description && (
              <div className="list-row list-description">
                <div className="list-text">
                  {getSafeText(item.description)}
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

export default ListSection;
